<template>
  <v-card outlined :loading="loading">
    <v-card-title>
      RESUMENES
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field
              type="date"
              label="Fecha:"
              v-model="fechaInicial"
          />
        </v-col>
        
        <v-col cols="12" md="2">
          <v-select
              v-model="bancoSeleccionado"
              :items="listaBancos"
              label="Banco:"
              clearable
          />
        </v-col>
        
        <v-col cols="12" md="2">  
          <v-btn color="blue-darken-4" title="Imprimir Reporte" class="mt-3"
            @click="imprimir()" :loading="loading">
            <v-icon>mdi-printer</v-icon>Imprimir
          </v-btn>
        </v-col>

        <v-col cols="12" md="2">  
          <v-btn color="orange-darken-2" title="Exportar a PDF" class="mt-3"
            @click="exportarPdf()" :loading="loading">
            <v-icon>mdi-file-pdf</v-icon>Exportar PDF
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">  
          <v-btn color="green darken-2" title="Exportar a Excel" class="mt-3" @click="exportarExcel()" :loading="loading">
            <v-icon>mdi-file-excel</v-icon>Exportar Excel
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">  
          <v-btn :color="filtrarLateArrivals ? 'warning' : 'grey'" :title="filtrarLateArrivals ? 'Mostrar todas las cajas' : 'Ocultar cajas 149, 309, 384'" class="mt-3" @click="filtrarLateArrivals = !filtrarLateArrivals">
            <v-icon>{{ filtrarLateArrivals ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>{{ filtrarLateArrivals ? 'Sin Banca Virtual' : 'Todas' }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-btn @click="getResumenTotalizado" color="success" :loading="loading">Resumen Totalizado</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <h3 class="text-center">RESUMEN TOTALIZADO <br> DE LOS RECAUDOS COBRADOS</h3>
        </v-col>
      </v-row>
      <v-row>
      <div id="areaImpresion">
        <head-report :title="`RESUMEN TOTALIZADO <br> DE LOS RECAUDOS COBRADOS `" :subtitle="` <strong> (Facturacion y Otros Ingresos)</strong> <br> Correspondiente a la Fecha: ${fechaLiteral} `"/>
        <v-simple-table class="simple-table" style="border-collapse: initial !important;">
          <thead>
          <tr>
            <th rowspan="2">CAJA <br> Nro.</th>
            <th rowspan="2">RESPONSABLE DE CAJA</th>
            <th rowspan="2">N° <br>Suc.</th>
            <th colspan="3">FACTURACION</th>
            <th colspan="3">OTROS INGRESOS</th>
            <th rowspan="2">TOTAL <br> FACTURAS <br> COBRADAS</th>
            <th rowspan="2">TOTAL MONTO <br> COBRADO Bs.</th>
            <th rowspan="2">TOTAL <br> FACTURAS <br> ANULADAS</th>
          </tr>
          <tr>
            <th>NRO. FACT. COB.</th>
            <th>MONTO COBRADO Bs.</th>
            <th>FACT. ANUL.</th>
            <th>NRO. FACT. COB.</th>
            <th>MONTO COBRADO Bs.</th>
            <th>FACT. ANUL.</th>
          </tr>
          </thead>
          <tbody>
            <template v-for="item in resumenTotalizadoFiltrado" >
            <tr v-for="(detalle, index) in item.detalle" :key="detalle.numero_caja + '-' + index">
                <td class="print">{{ detalle.numero_caja }}</td>
                <td>{{ detalle.nombre }}</td>
                <td class="print_right">{{ detalle.sucursal }}</td>

                <td class="print_right">{{ detalle.cantidad_consumo }}</td>
                <td class="print_right">{{ detalle.monto_consumo  }}</td>
                <td class="print_right">{{ detalle.cantidad_consumo_anulado }}</td>

                <td class="print_right">{{ detalle.cantidad_otros }}</td>
                <td class="print_right">{{ detalle.monto_otros }}</td>
                <td class="print_right">{{ detalle.cantidad_otros_anulado }}</td>

                <td class="print_right">{{ detalle.total_facturas_cobradas }}</td>
                <td class="print_right">{{ detalle.total_monto_cobrado  }}</td>
                <td class="print_right">{{ detalle.total_facturas_anuladas  }}</td>
              </tr> 
              <tr v-if="!bancoSeleccionado || bancoSeleccionado === item.entidad" :key="'entidad-'+item.entidad" style="background-color: #EAEAEA;"> 
                <th class="text-subtitle-1 font-weight-bold borde_izq"></th>
                <th class="text-subtitle-1 font-weight-bold borde_izq">{{ item.entidad  }}</th>
                <th></th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_cantidad_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_anulados_consumo }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_cantidad_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_anulados_otros }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_facturas_cobradas }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_monto_cobrado }}</th>
                <th class="text-subtitle-1 font-weight-bold print_right">{{ item.total_facturas_anuladas }}</th>
              </tr>
              
            </template>
            <tr v-if="!bancoSeleccionado" style="background-color: #EAEAEA;">
              <th class="text-subtitle-1"></th>
              <th class="text-subtitle-1">TOTALES</th>
              <th class="text-subtitle-1"></th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_cantidad_consumo }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_monto_cobrado }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_anulados_consumo }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_cantidad_otros }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_monto_otros  }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_anulados_otros }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_total_facturado }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_total_monto }}</th>
              <th class="text-subtitle-1">{{ resumenTotalizadoTotalesFiltrados.final_total_anulado }}</th>

            </tr>
          </tbody>
        </v-simple-table>
      </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {reportesBancoStore} from "@/store/reportesBancoStore";
import {ReportesBancoService} from "@/services/ReportesBancoService";
import FacturaHistorial from "@/views/facturas/FacturaHistorial.vue";
import { Reporte } from "@/addons/Reporte";
import HeadReport from "@/components/HeadReport.vue";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Component({
  name: "FacturaIndex",
  components: {FacturaHistorial, HeadReport}
})
export default class FacturaIndex extends Vue {
  private patterns = Pattern;
  private reportesBancoStore = reportesBancoStore();
  private reportesBancoService = ReportesBancoService.getInstance();

  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private bancoSeleccionado: string | null = null;
  private filtrarLateArrivals = false;
  private ventanillasExcluidas = [149, 309, 384];

  get fechaLiteral(): string {
    return this.reportesBancoStore.fechaLiteral;
  }
  get resumenTotalizado(): any[] {
    return this.reportesBancoStore.resumenTotalizado;
  }
  get resumenTotalizadoTotales(): any[] {
    return this.reportesBancoStore.resumenTotalizadoTotales;
  }

  get resumenTotalizadoTotalesFiltrados(): any {
    // Compute totals from filtered data (respecting excluded ventanillas)
    let datosParaProcesar = this.resumenTotalizadoFiltrado;
    
    if (datosParaProcesar.length === 0) {
      return {
        final_cantidad_consumo: "0",
        final_monto_cobrado: "0,00",
        final_anulados_consumo: "0",
        final_cantidad_otros: "0",
        final_monto_otros: "0,00",
        final_anulados_otros: "0",
        final_total_facturado: "0",
        final_total_monto: "0,00",
        final_total_anulado: "0"
      };
    }

    // Calculate totals from filtered detalle rows (excluding ventanillas if needed)
    let total_cantidad_consumo = 0;
    let total_monto_consumo = 0;
    let total_cantidad_otros = 0;
    let total_monto_otros = 0;
    let total_anulados_consumo = 0;
    let total_monto_anulados_consumo = 0;
    let total_anulados_otros = 0;
    let total_monto_anulados_otros = 0;

    datosParaProcesar.forEach((entidad: any) => {
      entidad.detalle.forEach((detalle: any) => {
        total_cantidad_consumo += detalle.cantidad_consumo || 0;
        total_monto_consumo += this.parseMonto(detalle.monto_consumo);
        total_cantidad_otros += detalle.cantidad_otros || 0;
        total_monto_otros += this.parseMonto(detalle.monto_otros);
        total_anulados_consumo += detalle.cantidad_consumo_anulado || 0;
        total_monto_anulados_consumo += this.parseMonto(detalle.monto_consumo_anulado);
        total_anulados_otros += detalle.cantidad_otros_anulado || 0;
        total_monto_anulados_otros += this.parseMonto(detalle.monto_otros_anulado);
      });
    });

    return {
      final_cantidad_consumo: total_cantidad_consumo.toString(),
      final_monto_cobrado: this.formatMonto(total_monto_consumo),
      final_anulados_consumo: total_anulados_consumo.toString(),
      final_cantidad_otros: total_cantidad_otros.toString(),
      final_monto_otros: this.formatMonto(total_monto_otros),
      final_anulados_otros: total_anulados_otros.toString(),
      final_total_facturado: (total_cantidad_consumo + total_cantidad_otros).toString(),
      final_total_monto: this.formatMonto(total_monto_consumo + total_monto_otros),
      final_total_anulado: (total_anulados_consumo + total_anulados_otros).toString()
    };
  }

  private parseMonto(monto: string | number): number {
    if (typeof monto === 'number') return monto;
    if (!monto) return 0;
    const str = monto.toString().replace(/\./g, '').replace(/,/, '.');
    return parseFloat(str) || 0;
  }

  private formatMonto(valor: number): string {
    return valor.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  
  get loading(): boolean {
    return this.reportesBancoStore.loading;
  }

  get listaBancos(): any[] {
    const bancos = new Set<string>();
    this.resumenTotalizado.forEach(entidad => {
      if (entidad.entidad) {
        bancos.add(entidad.entidad);
      }
    });
    return Array.from(bancos).sort();
  }

  get resumenTotalizadoFiltrado(): any[] {
    let datos = !this.bancoSeleccionado 
      ? this.resumenTotalizado 
      : this.resumenTotalizado.filter(entidad => entidad.entidad === this.bancoSeleccionado);
    
    // Si filtrarLateArrivals está activo, excluir ventanillas
    if (this.filtrarLateArrivals) {
      datos = datos.map(entidad => {
        const detalleFiltered = entidad.detalle.filter((d: any) => !this.ventanillasExcluidas.includes(d.numero_caja));
        
        // Recalcular totales para esta entidad solo con los detalles filtrados
        let total_cantidad_consumo = 0;
        let total_monto_consumo = 0;
        let total_cantidad_otros = 0;
        let total_monto_otros = 0;
        let total_anulados_consumo = 0;
        let total_monto_anulados_consumo = 0;
        let total_anulados_otros = 0;
        let total_monto_anulados_otros = 0;

        detalleFiltered.forEach((d: any) => {
          total_cantidad_consumo += d.cantidad_consumo || 0;
          total_monto_consumo += this.parseMonto(d.monto_consumo);
          total_cantidad_otros += d.cantidad_otros || 0;
          total_monto_otros += this.parseMonto(d.monto_otros);
          total_anulados_consumo += d.cantidad_consumo_anulado || 0;
          total_monto_anulados_consumo += this.parseMonto(d.monto_consumo_anulado);
          total_anulados_otros += d.cantidad_otros_anulado || 0;
          total_monto_anulados_otros += this.parseMonto(d.monto_otros_anulado);
        });

        return {
          ...entidad,
          detalle: detalleFiltered,
          // Override totals with recalculated values
          total_cantidad_consumo: total_cantidad_consumo,
          total_consumo: this.formatMonto(total_monto_consumo),
          total_cantidad_otros: total_cantidad_otros,
          total_otros: this.formatMonto(total_monto_otros),
          total_anulados_consumo: total_anulados_consumo,
          total_monto_anulados_consumo: this.formatMonto(total_monto_anulados_consumo),
          total_anulados_otros: total_anulados_otros,
          total_monto_anulados_otros: this.formatMonto(total_monto_anulados_otros),
          total_facturas_cobradas: total_cantidad_consumo + total_cantidad_otros,
          total_facturas_anuladas: total_anulados_consumo + total_anulados_otros,
          total_monto_cobrado: this.formatMonto(total_monto_consumo + total_monto_otros)
        };
      });
    }
    
    return datos;
  }

  mounted() {
    //this.listar();
  }

  imprimir() {
    const css = ".print {border-top-left-radius: 5px !important; border-bottom-left-radius: 7px; border-color: red;} .emision { font-size: x-small !important; font-style: italic !important; }"
    const p = new Reporte('areaImpresion');
    p.orientacion = 'horizontal';
    p.otroCss = css;
    p.imprimir();
  }

  exportarPdf() {
    try {
      console.log('exportarPdf invoked');
      const pdf = new jsPDF({orientation: 'landscape', unit: 'mm', format: 'a4'});
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 10;

      // Encabezado — aún más compacto (líneas muy próximas)
      const fecha = new Date();
      const fechaFormato = fecha.toLocaleString('es-ES');
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(7);
      pdf.text('SERVICIO LOCAL DE ACUEDUCTOS Y ALCANTARILLADO', margin, margin);
      pdf.setFontSize(6.5);
      pdf.text('SeLA - Oruro', margin, margin + 4);
      pdf.setFontSize(6.5);
      pdf.text(`FECHA Y HORA: ${fechaFormato}`, pageWidth - margin - 100, margin);

      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.text('RESUMEN TOTALIZADO', pageWidth / 2, margin + 10, {align: 'center'});
      pdf.setFontSize(8);
      pdf.text('DE LOS RECAUDOS COBRADOS', pageWidth / 2, margin + 13, {align: 'center'});
      pdf.setFontSize(7);
      pdf.setFont('helvetica', 'normal');
      pdf.text('(Facturacion y Otros Ingresos)', pageWidth / 2, margin + 16, {align: 'center'});
      pdf.text(`Correspondiente a la Fecha: ${this.fechaInicial}`, pageWidth / 2, margin + 18, {align: 'center'});

      // Build table data for autotable
      const head = [
        [
          {content: 'CAJA Nro', rowSpan: 2},
          {content: 'RESPONSABLE DE CAJA', rowSpan: 2},
          {content: 'N° Suc.', rowSpan: 2},
          {content: 'FACTURACION', colSpan: 3, styles: {halign: 'center'}},
          {content: 'OTROS INGRESOS', colSpan: 3, styles: {halign: 'center'}},
          {content: 'TOTAL FACTURAS COBRADAS', rowSpan: 2},
          {content: 'TOTAL MONTO COBRADO Bs.', rowSpan: 2},
          {content: 'TOTAL FACTURAS ANULADAS', rowSpan: 2}
        ],
        [
          'NRO. FACT. COB.', 'MONTO COBRADO Bs.', 'FACT. ANUL.',
          'NRO. FACT. COB.', 'MONTO COBRADO Bs.', 'FACT. ANUL.'
        ]
      ];

      const body: any[] = [];
      const subtotalRowIndexes: number[] = [];
      let bodyRowIndex = 0;

      this.resumenTotalizadoFiltrado.forEach((entidad: any) => {
        entidad.detalle.forEach((d: any) => {
          body.push([
            d.numero_caja || '',
            d.nombre || '',
            d.sucursal || '',
            d.cantidad_consumo || 0,
            d.monto_consumo || '0,00',
            d.cantidad_consumo_anulado || 0,
            d.cantidad_otros || 0,
            d.monto_otros || '0,00',
            d.cantidad_otros_anulado || 0,
            d.total_facturas_cobradas || 0,
            d.total_monto_cobrado || '0,00',
            d.total_facturas_anuladas || 0
          ]);
          bodyRowIndex++;
        });
        // add entidad subtotal row and record its index
        body.push([
          '',
          entidad.entidad || '',
          '',
          entidad.total_cantidad_consumo || 0,
          entidad.total_consumo || '0,00',
          entidad.total_anulados_consumo || 0,
          entidad.total_cantidad_otros || 0,
          entidad.total_otros || '0,00',
          entidad.total_anulados_otros || 0,
          entidad.total_facturas_cobradas || 0,
          entidad.total_monto_cobrado || '0,00',
          entidad.total_facturas_anuladas || 0
        ]);
        subtotalRowIndexes.push(bodyRowIndex);
        bodyRowIndex++;
      });

      // If no bank filter, add global totals row
      if (!this.bancoSeleccionado) {
        body.push([
          '', 'TOTALES', '',
          this.resumenTotalizadoTotalesFiltrados.final_cantidad_consumo || '0',
          this.resumenTotalizadoTotalesFiltrados.final_monto_cobrado || '0,00',
          this.resumenTotalizadoTotalesFiltrados.final_anulados_consumo || 0,
          this.resumenTotalizadoTotalesFiltrados.final_cantidad_otros || 0,
          this.resumenTotalizadoTotalesFiltrados.final_monto_otros || '0,00',
          this.resumenTotalizadoTotalesFiltrados.final_anulados_otros || 0,
          this.resumenTotalizadoTotalesFiltrados.final_total_facturado || '0',
          this.resumenTotalizadoTotalesFiltrados.final_total_monto || '0,00',
          this.resumenTotalizadoTotalesFiltrados.final_total_anulado || 0
        ]);
        subtotalRowIndexes.push(bodyRowIndex);
        bodyRowIndex++;
      }

      const startY = margin + 20;

      // compact autotable: chunk into pages with a maximum number of body rows per page
      const maxRowsPerPage = 27;
      const usableWidth = pageWidth - margin * 2;
      // increase widths for RESPONSABLE and the TOTAL columns so headers fit fully
      const columnPercents = [0.04, 0.18, 0.04, 0.08, 0.08, 0.08, 0.08, 0.08, 0.08, 0.09, 0.09, 0.08];
      const baseColumnStyles: any = {};
      for (let i = 0; i < columnPercents.length; i++) {
        baseColumnStyles[i] = { cellWidth: Math.max(10, Math.floor(usableWidth * columnPercents[i])) };
      }
      // responsible column smaller; content truncated if needed
      baseColumnStyles[1].overflow = 'ellipsize';
      baseColumnStyles[1].halign = 'left';
      [3,4,5,6,7,8,9,10,11].forEach(idx => { baseColumnStyles[idx].halign = 'right'; });

      // paginate groups using dynamic rows-per-page estimates so subtotals stay with their details
      const groups: any[] = [];
      this.resumenTotalizadoFiltrado.forEach((entidad: any) => {
        const grp: any[] = [];
        entidad.detalle.forEach((d: any) => {
          grp.push([
            d.numero_caja || '',
            d.nombre || '',
            d.sucursal || '',
            d.cantidad_consumo || 0,
            d.monto_consumo || '0,00',
            d.cantidad_consumo_anulado || 0,
            d.cantidad_otros || 0,
            d.monto_otros || '0,00',
            d.cantidad_otros_anulado || 0,
            d.total_facturas_cobradas || 0,
            d.total_monto_cobrado || '0,00',
            d.total_facturas_anuladas || 0
          ]);
        });
        grp.push([
          '',
          entidad.entidad || '',
          '',
          entidad.total_cantidad_consumo || 0,
          entidad.total_consumo || '0,00',
          entidad.total_anulados_consumo || 0,
          entidad.total_cantidad_otros || 0,
          entidad.total_otros || '0,00',
          entidad.total_anulados_otros || 0,
          entidad.total_facturas_cobradas || 0,
          entidad.total_monto_cobrado || '0,00',
          entidad.total_facturas_anuladas || 0
        ]);
        groups.push(grp);
      });

      if (!this.bancoSeleccionado) {
        groups.push([
          [
            '', 'TOTALES', '',
            this.resumenTotalizadoTotalesFiltrados.final_cantidad_consumo || '0',
            this.resumenTotalizadoTotalesFiltrados.final_monto_cobrado || '0,00',
            this.resumenTotalizadoTotalesFiltrados.final_anulados_consumo || 0,
            this.resumenTotalizadoTotalesFiltrados.final_cantidad_otros || 0,
            this.resumenTotalizadoTotalesFiltrados.final_monto_otros || '0,00',
            this.resumenTotalizadoTotalesFiltrados.final_anulados_otros || 0,
            this.resumenTotalizadoTotalesFiltrados.final_total_facturado || '0',
            this.resumenTotalizadoTotalesFiltrados.final_total_monto || '0,00',
            this.resumenTotalizadoTotalesFiltrados.final_total_anulado || 0
          ]
        ]);
      }

      // estimate how many rows fit per page dynamically
      const pageHeight = pdf.internal.pageSize.getHeight();
      const bottomMargin = 10;
      const estimatedRowHeight = 4; // mm per row (conservative)
      const firstPageAvailable = pageHeight - startY - bottomMargin;
      const firstPageCapacity = Math.max(5, Math.floor(firstPageAvailable / estimatedRowHeight));
      const otherStartY = margin + 10;
      const otherPageAvailable = pageHeight - otherStartY - bottomMargin;
      const otherPageCapacity = Math.max(5, Math.floor(otherPageAvailable / estimatedRowHeight));

      const pages: any[] = [];
      let current: any[] = [];
      let currentCapacity = firstPageCapacity;
      let firstPage = true;

      const pushCurrent = () => {
        if (current.length > 0) {
          pages.push(current);
          current = [];
        }
      };

      for (let g of groups) {
        // if group fits in current page, append
        if (current.length + g.length <= currentCapacity) {
          current = current.concat(g);
        } else {
          // if current has content, push it and move to next page
          if (current.length > 0) {
            pushCurrent();
            firstPage = false;
            currentCapacity = otherPageCapacity;
          }

          // if group fits in an empty page, place it
          if (g.length <= currentCapacity) {
            current = current.concat(g);
          } else {
            // group larger than a page: split it into slices that respect capacity
            let start = 0;
            while (start < g.length) {
              const slice = g.slice(start, start + currentCapacity);
              pages.push(slice);
              start += currentCapacity;
              // after first slice, subsequent pages use otherPageCapacity
              currentCapacity = otherPageCapacity;
            }
            // reset current to empty and continue
            current = [];
            firstPage = false;
            currentCapacity = otherPageCapacity;
          }
        }
      }
      if (current.length) pages.push(current);

      // render pages
      for (let p = 0; p < pages.length; p++) {
        const pageBody = pages[p];
        if (p > 0) {
          pdf.addPage();
        }

        // compute local subtotal indexes: rows where first cell is empty and second is non-empty
        const localSubtotalIndexes: number[] = [];
        pageBody.forEach((r: any, idx: number) => {
          if ((r[0] === '' || r[0] === null || r[0] === undefined) && r[1]) {
            localSubtotalIndexes.push(idx);
          }
        });

        const headForChunk = p === 0 ? head : [];
        const localStartY = p === 0 ? startY : margin + 10;

        (autoTable as any)(pdf, {
          startY: localStartY,
          head: headForChunk,
          body: pageBody,
          theme: 'grid',
          tableWidth: pageWidth - margin * 2,
          styles: {
            fontSize: 6,
            cellPadding: 0.6,
            overflow: 'ellipsize'
          },
          headStyles: {
            fillColor: [234,234,234],
            textColor: 0,
            fontStyle: 'bold',
            fontSize: 8,
            cellPadding: 1
          },
          columnStyles: baseColumnStyles,
          margin: { left: margin, right: margin },
          didParseCell: function (data: any) {
            if (localSubtotalIndexes.indexOf(data.row.index) !== -1) {
              data.cell.styles.fillColor = [200,200,200];
              data.cell.styles.fontStyle = 'bold';
              if (data.column.index === 1) {
                data.cell.styles.halign = 'left';
              }
            }
            if (data.section === 'head') {
              data.cell.styles.fontSize = 8;
              data.cell.styles.cellPadding = 1;
              data.cell.styles.overflow = 'linebreak';
            }
          },
          didDrawPage: function (data: any) {
            const pageSize = pdf.internal.pageSize;
            const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            pdf.setFontSize(8);
            const pageCount = (pdf as any).internal.getNumberOfPages();
            pdf.text(`Página ${pageCount}`, pageWidth - margin - 20, pageHeight - 5);
          }
        });
      }

      const fileName = `${this.bancoSeleccionado || 'Todos-Bancos'}-${this.fechaInicial}.pdf`;
      pdf.save(fileName);
    } catch (err:any) {
      console.error('exportarPdf error', err);
      alert('Error generando PDF: ' + (err && err.message ? err.message : err));
    }
  }

  async exportarExcel() {
    // dynamic import to avoid build-time failure if xlsx is not installed
    try {
      const mod = await import('xlsx');
      const XLSX = (mod as any).default || (mod as any);
      const rows: any[] = [];
      // header
      rows.push([
        'Entidad','Caja Nro','Responsable','Sucursal',
        'Cant. Consumo','Monto Consumo','Cant. Consumo Anulado',
        'Cant. Otros','Monto Otros','Cant. Otros Anulado',
        'Total Facturas Cobradas','Total Monto Cobrado','Total Facturas Anuladas'
      ]);

      this.resumenTotalizadoFiltrado.forEach((entidad:any) => {
        // detalle rows only (sin totales por entidad ni filas en blanco)
        entidad.detalle.forEach((d:any) => {
          rows.push([
            entidad.entidad || '',
            d.numero_caja || '',
            d.nombre || '',
            d.sucursal || '',
            d.cantidad_consumo || 0,
            d.monto_consumo || '0,00',
            d.cantidad_consumo_anulado || 0,
            d.cantidad_otros || 0,
            d.monto_otros || '0,00',
            d.cantidad_otros_anulado || 0,
            d.total_facturas_cobradas || 0,
            d.total_monto_cobrado || '0,00',
            d.total_facturas_anuladas || 0
          ]);
        });
      });

      // Grand totals row at the end
      rows.push([
        'TOTALES', '', '', '',
        this.resumenTotalizadoTotalesFiltrados.final_cantidad_consumo || '0',
        this.resumenTotalizadoTotalesFiltrados.final_monto_cobrado || '0,00',
        this.resumenTotalizadoTotalesFiltrados.final_anulados_consumo || 0,
        this.resumenTotalizadoTotalesFiltrados.final_cantidad_otros || 0,
        this.resumenTotalizadoTotalesFiltrados.final_monto_otros || '0,00',
        this.resumenTotalizadoTotalesFiltrados.final_anulados_otros || 0,
        this.resumenTotalizadoTotalesFiltrados.final_total_facturado || '0',
        this.resumenTotalizadoTotalesFiltrados.final_total_monto || '0,00',
        this.resumenTotalizadoTotalesFiltrados.final_total_anulado || 0
      ]);

      const ws = XLSX.utils.aoa_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'ResumenBanco');
      const filename = `${this.bancoSeleccionado || 'Todos-Bancos'}-${this.fechaInicial}.xlsx`;
      XLSX.writeFile(wb, filename);
    } catch (err:any) {
      console.error(err);
      alert('Para exportar a Excel instale la dependencia: npm install xlsx --save y reinicie el servidor de desarrollo.');
    }
  }

  getResumenTotalizado() {
    this.reportesBancoStore.resumenTotalizado = [];
    this.reportesBancoStore.resumenTotalizadoTotales = [];
    const data = {
      fecha: this.fechaInicial,
    };
    this.reportesBancoService.resumenTotalizado(data);
  }

}
</script>

<style scoped>
tr:nth-child(even) {
  background-color: #FAFAFA;
}

.simple-table {
  border: 1px solid #DDDDDD;
}
.simple-table th {
  border: 1px solid #DDDDDD;
  padding: 5px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  background-color: #EAEAEA;
}
.simple-table td {
  border: 1px solid #DDDDDD;
  padding: 5px;
  font-size: 12px;
}
</style>